const worker = new SharedWorker('/sw.js');
worker.port.start();

export const eventBus = new EventTarget();

const requests = new Map();

worker.port.onmessage = event => {
  const message = event.data;

  if (message.type === 'ws:open') {
    eventBus.dispatchEvent(new CustomEvent('ws-open'));
    return;
  }

  if (message.type === 'ws:close') {
    eventBus.dispatchEvent(new CustomEvent('ws-close'));
    return;
  }

  if (message.type === 'ws:authorize-needed') {
    eventBus.dispatchEvent(new CustomEvent('authorize-needed'));
    return;
  }

  if (message.action === 'notification') {
    eventBus.dispatchEvent(new CustomEvent('notification', { detail: message.data }));
    return;
  }

  if (message.id) {
    const callback = requests.get(message.id);
    if (callback) {
      callback(message);
      requests.delete(message.id);
    }
  }
};

export const sendMessage = message => {
  worker.port.postMessage(message);
};

export const sendRequest = payload => {
  if (!payload.id) {
    payload.id = crypto.randomUUID();
  }

  const deferred = {};

  const promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });

  requests.set(payload.id, response => {
    if (response.error) {
      deferred.reject(response.error);
    } else {
      deferred.resolve(response.data);
    }
  });

  const timeoutId = setTimeout(() => {
    if (requests.has(payload.id)) {
      requests.delete(payload.id);
      deferred.reject(new Error('Request timed out'));
    }
  }, 5000);

  promise.finally(() => clearTimeout(timeoutId));

  sendMessage({ type: 'send', id: payload.id, payload: JSON.stringify(payload) });

  return promise;
};
